module.exports = __webpack_public_path__ + "img/pic_15s.1a394406.gif";